import loadable from '@loadable/component';
export const PlayFlatpickr = loadable(() => import('./HeavyPlayFlatpickr').then(mod => mod.HeavyPlayFlatpickr));